import React from 'react';
import { Card, CardContent, Typography, Box, Chip } from '@mui/material';
import { RoadmapItem } from '../../types';
import { isVersionLabel } from '../../utils';

interface IssueCardProps {
    item: RoadmapItem;
    onClick: (item: RoadmapItem) => void;
}

const IssueCard: React.FC<IssueCardProps> = ({ item, onClick }) => {
    return (
        <Card
            sx={{
                mb: 1.5,
                cursor: 'pointer',
                borderRadius: 2,
            }}
            onClick={() => onClick(item)}
        >
            <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
                <Typography
                    variant="h6"
                    component="h3"
                    gutterBottom
                    sx={{
                        mb: 1,
                        lineHeight: 1.3,
                        fontSize: '0.95rem'
                    }}
                >
                    {item.title}
                </Typography>
                <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', alignItems: 'center' }}>
                    {item.assignee && (
                        <Chip
                            label={item.assignee.name}
                            size="small"
                            variant="outlined"
                            sx={{ fontSize: '0.7rem' }}
                        />
                    )}

                    {/* Category labels (Feature, User interface, Modelling, etc.) */}
                    {item.labels?.nodes && item.labels.nodes
                        .filter(label => {
                            // Show category labels - exclude version-related labels
                            return !isVersionLabel(label.name);
                        })
                        .map((label) => (
                            <Chip
                                key={label.id}
                                label={label.name}
                                size="small"
                                variant="outlined"
                                sx={{
                                    fontSize: '0.65rem',
                                    backgroundColor: `${label.color}20`,
                                    borderColor: label.color,
                                    color: label.color
                                }}
                            />
                        ))
                    }
                </Box>
            </CardContent>
        </Card>
    );
};

export default IssueCard;
